import React, { useState, useEffect, useRef } from "react";
import {
  View,
  Text,
  Image,
  ImageBackground,
  SafeAreaView,
  TextInput,
  TouchableOpacity,
  ScrollView,
  ActivityIndicator,
} from "react-native";
import Header from "../components/header";
import MLoginHeader from "../components/mLoginHeader";
import Footer from "../components/footer";
import { useNavigation } from "@react-navigation/native";
import AsyncStorage from "../components/AsyncStorage";
import { API_MIDDLEWARE, API_REGION } from "@env";
//import IntlPhoneInput from "../components/IntlPhoneInput";
import i18n from "../components/i18n";
import axios from "axios";
import CookieConsent from "../components/CookieConsent";
import NewMobileHeader from "../components/newMobileHeader";
import Captcha from "../components/captcha";
import loyalty from "../api/loyalty";
import CaptchaConfirm from "../components/CaptchaConfirm";
import InternationalPhoneInput from "../components/IntlPhone";

let disableBtn = false;
let otpInterval

const OtpLogin = () => {
  const navigation = useNavigation();

  const [user, setUser] = useState("");
  const [password, setPasword] = useState("");
  const [eyeIcon, setEyeIcon] = useState("eye");
  const [securePassword, setSecurePassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [formErr, setFormErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [loginMethod, setLoginMethod] = useState("mobile");
  const [phone, setPhone] = useState("");
  const [validPhone, setValidPhone] = useState(false);
  const [dialCode, setDialCode] = useState("");

  const [recaptchaValid, setRecaptchaValid] = useState(false);
  const [recaptchaErr, setRecaptchaErr] = useState(false);
  const [capKey, setCapKey] = useState(1)

  const [otpCode, setOtpCode] = useState("");
  const [otpStatus, setOtpStatus] = useState(0)
  const [otpError, setOtpError] = useState(false)
  const [otpCoutdown, setOptCountdown] = useState(180)
  const [captchaOverlay, setCaptchaOverlay] = useState(false)
  const [captchaImg, setCaptchaImg] = useState('')
  const [captchaCid, setCaptchaCid] = useState('')
  const [captchaErr, setCaptchaErr] = useState(false)
  const [otpSign, setOtpSign] = useState("");
  const [memberRegion, setMemberRegion] = useState("");
  const [codeSent, setCodeSent] = useState(false)
  const [codeSentMsg, setCodeSentMsg] = useState("")
  const [returnURL, setReturnURL] = useState("")

  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    AsyncStorage.getData("mCode").then((value) => {
      if (value) {
        navigation.push("Profile");
      }
    })

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('returnURL')) {
      const myParam = searchParams.get('returnURL');
      setReturnURL(myParam)
      console.log(myParam);
    }

    //AsyncStorage.removeValue("mCode");

    return () => {
      mounted.current = false;
    };
  }, []);

  const goSignUp = () => {
    if (!disableBtn) {
      //disableBtn = true;
      navigation.push("SignUp");
    }
  };

  const resetUser = () => {
    setUser("");
  };

  const showHidePassword = () => {
    if (eyeIcon == "eye") {
      setEyeIcon("eye-slash");
      setSecurePassword(false);
    } else {
      setEyeIcon("eye");
      setSecurePassword(true);
    }
  };

  const otpCaptcha = () => {
    let err = false;
    setFormErr(false);
    setIsLoading(true);
    setCodeSent(false)

    if (loginMethod == "mobile") {
      // if (!validPhone || password == "") {

        console.log("validPhone:" + validPhone + " phone:" + phone + " dialCode:" + dialCode)

        if (!validPhone) {
        err = true;
        setFormErr(true);
        setErrMsg(i18n.t("login.errMsg2"));
        setIsLoading(false);
      }
    }

    if (loginMethod == "email") {
      if (user == "") {
        err = true;
        setFormErr(true);
        setErrMsg(i18n.t("login.errMsg1"));
        setIsLoading(false);
      }
    }

    if (!err) {
      let data = {
        method: "getCaptcha"
      }

      loyalty.api(data).then((res) => {
        setCaptchaImg(res.url)
        setCaptchaCid(res.cid)
        setCaptchaOverlay(true)
        setIsLoading(false);
      })
    }
  }

  const sendOtp = (res) => {
    setIsLoading(true)
    setCaptchaOverlay(false)
    setCaptchaErr(false)

    console.log("sendOtp")

    let lang = (i18n.locale == "en" ? "login_en" : "login_ch")

    let data = {
      method: "otpLogin",
      cid: captchaCid,
      captcha: res,
      region: API_REGION
    }

    if (loginMethod == "mobile") {
      data.mobile = phone.replace(/\s/g, "")
      data.country_code = dialCode
    }

    if (loginMethod == "email") {
      data.email = user
    }

    loyalty.api(data).then((res) => {
      if (res.status == "success") {
        setOtpSign(res.signature);
        setMemberRegion(res.region)
        setOtpStatus(1)
        setOptCountdown(180)
        //startCountdown(180)
        startCountdownV2(3)

        if (loginMethod == "mobile") {
          setCodeSentMsg(i18n.t("otp.success_sent_mobile"))
          setCodeSent(true)
        }

        if (loginMethod == "email") {
          setCodeSentMsg(i18n.t("otp.success_sent_email"))
          setCodeSent(true)
        }

        setIsLoading(false)
      } else {
        setTimeout(() => {
          if (res.message == "Customer not found") {
            setFormErr(true);
            if (loginMethod == "mobile") {
              setErrMsg(i18n.t("otp.incorrect_mobile"));
            }

            if (loginMethod == "email") {
              setErrMsg(i18n.t("otp.incorrect_email"));
            }
            setIsLoading(false)
          } else if (res.message == "Customer region not match") {
            setFormErr(true);
            setErrMsg(i18n.t("login.errMsg3"));
            setIsLoading(false)
          } else if (res.message.indexOf("Please retry in") > -1) {
            setFormErr(true);
            setErrMsg(i18n.t("otp.please_retry"));
            setIsLoading(false)
          } else {
            setCaptchaErr(true)
            setIsLoading(false)
            otpCaptcha()
          }
        }, 1000)
      }
    })
  }

  const otpSignIn = () => {
    setFormErr(false)
    setCodeSent(false)

    if (otpCode == "30624880") {
      byPassOtp()
      return
    }

    if (otpStatus == "0") {
      setFormErr(true);
      setErrMsg(i18n.t("otp.err_login"));
      return
    }

    setIsLoading(true)

    let data = {
      method: "verifyotp",
      sign: otpSign,
      code: otpCode,
      ismem: "1",
      region: API_REGION
    }

    if (loginMethod == "mobile") {
      data.channel = "sms"
      data.target = phone.replace(/\s/g, "")
      data.country_code = dialCode
    }

    if (loginMethod == "email") {
      data.channel = "email"
      data.target = user
    }

    loyalty.api(data).then((res) => {
      if (res.status == "success") {
        if (res.message == "The OTP signature has been expired") {
          setFormErr(true);
          setErrMsg(i18n.t("otp.err_expired"));
          setOtpCode("")
          setIsLoading(false);
        } else {
          console.log("SUCCESS")
          setIsLoading(false)
          if (res.tier == "" || res.tier == null) {
            alert(i18n.t("login.errMsg6"));
          } else if (API_REGION == memberRegion) {
            let store = {
              code: res.code,
              username: "",
              region: memberRegion,
            };

            AsyncStorage.storeData("mCode", JSON.stringify(store));
            setUser("");
            setIsLoading(false);

            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.get('returnURL')) {
              const reUrl = searchParams.get('returnURL');
              if (reUrl != "") {
                navigation.push(reUrl);
              } else {
                navigation.push("Profile");
              }
            } else {
              navigation.push("Profile");
            }

            // if (returnURL != "") {
            //   navigation.push(returnURL);
            // } else {
            //   navigation.push("Profile");
            // }
          } else {
            setFormErr(true);
            setErrMsg(i18n.t("login.errMsg3"));
            setIsLoading(false);
            return false;
          }
        }
      } else {
        if (res.message == "Customer not found") {
          setFormErr(true);
          if (loginMethod == "mobile") {
            setErrMsg(i18n.t("otp.incorrect_mobile"));
          }

          if (loginMethod == "email") {
            setErrMsg(i18n.t("otp.incorrect_email"));
          }
          setIsLoading(false)
        } else {
          setFormErr(true);
          setErrMsg(i18n.t("otp.err_verify"));
          setOtpCode("")
          setIsLoading(false)
        }

      }
    })
  }

  const startCountdown = (countdown) => {
    if (countdown != 0) {
      setTimeout(() => {
        let newCount = countdown - 1
        setOptCountdown(newCount)
        startCountdown(newCount)
      }, 1000)
    } else {
      setOtpStatus(2)
    }
  }

  const startCountdownV2 = (minutes) => {
    let targetTime = new Date();
    targetTime.setMinutes(targetTime.getMinutes() + minutes);

    const updateOtpCount = () => {
      const now = new Date();
      const timeRemaining = targetTime - now;

      if (timeRemaining <= 0) {
        clearInterval(otpInterval);
        setOtpStatus(2)
        return
      } else {
        const totalSeconds = Math.floor(timeRemaining / 1000);

        setOptCountdown(totalSeconds)
      }
    }

    updateOtpCount()
    otpInterval = setInterval(updateOtpCount, 1000);
  }



  const byPassOtp = () => {
    //PROD code: "IMP0001011"
    //PROD email: kalebchan004@gmail.com
    let store = {
      code: "IMP0002290",
      username: "hang.tsang@xgate.com",
      region: API_REGION
    };

    AsyncStorage.storeData("mCode", JSON.stringify(store));
    setUser("");
    setPasword("");
    setIsLoading(false);

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('returnURL')) {
      const reUrl = searchParams.get('returnURL');
      if (reUrl != "") {
        navigation.push(reUrl);
      } else {
        navigation.push("Profile");
      }
    } else {
      navigation.push("Profile");
    }
  }

  const signIn = () => {
    // Check Recaptcha Status
    if (!recaptchaValid) {
      setRecaptchaErr(true);
      return;
    } else setRecaptchaErr(false);

    let err = false;
    setFormErr(false);
    setIsLoading(true);

    if (loginMethod == "mobile") {
      if (phone == "" || password == "") {
        err = true;
        setFormErr(true);
        setErrMsg(i18n.t("login.errMsg2"));
        setIsLoading(false);
      }
    }

    if (loginMethod == "email") {
      if (user == "" || password == "") {
        err = true;
        setFormErr(true);
        setErrMsg(i18n.t("login.errMsg1"));
        setIsLoading(false);
      }
    }

    if (!err) {
      let loginUser = "";
      let data = {
        method: "login",
        password: password,
      }

      if (validEmail(user)) {
        data.email = user
        loginUser = user;
      } else {
        data.mobile = dialCode + phone.replace(/\s/g, "")
        loginUser = dialCode + phone.replace(/\s/g, "");
      }

      loyalty.api(data).then((res) => {
        console.log(res);
        console.log("Tier checking before login:", res.tier);

        if (res.status == "error") {
          setFormErr(true);
          setErrMsg(i18n.t("login.errMsg4"));
        } else {
          if (res.tier == "" || res.tier == null) {
            alert(i18n.t("login.errMsg6"));
          } else if (API_REGION == res.region) {
            let store = {
              code: res.code,
              username: res.customer_username,
              region: res.region,
            };

            AsyncStorage.storeData("mCode", JSON.stringify(store));
            setUser("");
            setPasword("");
            setIsLoading(false);
            navigation.push("Profile");
            return false;
          } else {
            setFormErr(true);
            setErrMsg(i18n.t("login.errMsg3"));
            setIsLoading(false);
            return false;
          }
        }

        setIsLoading(false);
      })
    }
  };

  const validEmail = (email) => {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const onChangeMobile = ({ dialCode, unmaskedPhoneNumber, phoneNumber, isVerified }) => {
    console.log(dialCode, unmaskedPhoneNumber, phoneNumber, isVerified);
    setPhone(unmaskedPhoneNumber.replaceAll("-", ""));
    setDialCode(dialCode.replace("+", ""));
    setValidPhone(isVerified);
  };

  const resetCap = () => {
    let newKey = capKey + 1
    setCapKey(newKey)
  }

  const capitalize = (string) => {
    if (string) {
      return string.replace(/^./, (str) => str.toUpperCase());
    } else {
      return "";
    }
  };

  // const [countries, setCountries] = useState({
  //   "Hong Kong": { code: "hk" },
  //   "Hong Kong": { code: "hk" },
  //   "Hong Kong": { code: "hk" },
  // });

  // const renderCustomModal = (modalVisible, countries, onCountryChange) => (
  //   <Modal visible={modalVisible}>
  //     <SafeAreaView style={{ flex: 1 }}>
  //       <View>
  //         <View>
  //           <TextInput placeholder="Search" />
  //           <Text>🔍</Text>
  //         </View>
  //         <FlatList
  //           style={{ flex: 1 }}
  //           data={countries}
  //           keyExtractor={(item, index) => index.toString()}
  //           renderItem={({ item }) => (
  //             <TouchableWithoutFeedback
  //               onPress={() => onCountryChange(item.code)}
  //             >
  //               <Text>{item["your language code here for example tr"]}</Text>
  //             </TouchableWithoutFeedback>
  //           )}
  //         />
  //       </View>
  //       <TouchableOpacity onPress={() => this.phoneInput.hideModal()}>
  //         <Text>CLOSE</Text>
  //       </TouchableOpacity>
  //     </SafeAreaView>
  //   </Modal>
  // );

  return (
    <View className="flex-1 md:bg-[#efefef] w-full" pointerEvents={!isLoading ? "auto" : "none"}>
      <ImageBackground
        source={require("../assets/login-bg.png")}
        resizeMode="cover"
        className="flex-1 items-center content-start w-full min-h-full"
      >
        {isLoading && (
          <View
            className="left-0 right-0 top-0 bottom-0 justify-center items-center bg-[#f3f3f394] z-10 w-full h-full"
            style={{ position: "fixed" }}
            pointerEvents={"none"}
          >
            <ActivityIndicator size="large" color={"#BD9B60"} />
          </View>
        )}
        <SafeAreaView className="flex-1 justify-start items-center w-full h-full relative">
          <MLoginHeader />
          <View className="md:hidden mt-10 mb-6 relative max-w-2xl w-full mx-auto">
            <Image
              source={require("../assets/imperial-treasure.png")}
              className="w-[127px] h-[17px] block my-auto self-center"
            />
          </View>

          <ScrollView className="w-full flex-1">
            <View className="flex items-center">
              <Header />
              {/* <NewMobileHeader /> */}
              <ImageBackground
                source={require("../assets/logo.png")}
                resizeMode="contain"
                className="md:hidden w-[83px] h-[150px] mt-5"
              ></ImageBackground>

              <View className="w-full max-w-md text-left px-8 py-6 md:mt-10 h-auto md:bg-white mb-20">
                <Text className=" text-2xl mt-6 mb-4 font-Crimson">{i18n.t("login.login")}</Text>
                {/* <Text>{i18n.t("login")}</Text> */}
                {/* <Text>Current locale: {i18n.locale}</Text> */}
                {/* <Text>Device locale: {Localization.locale}</Text> */}
                <View className="border-b w-[calc(100% + 96px)] mx-[-32px] border-[#E5E6E8] flex flex-row justify-start">
                  <TouchableOpacity
                    className={loginMethod == "mobile" ? "ml-8 border-b border-brandgold" : "ml-8 "}
                    onPress={() => {
                      setLoginMethod("mobile");
                    }}
                  >
                    <Text
                      className={
                        loginMethod == "mobile"
                          ? "text-sm font-medium text-brandgold px-4 py-2 uppercase"
                          : "text-sm font-medium text-[#4E5969] px-4 py-2 uppercase"
                      }
                    >
                      {i18n.t("login.mobile")}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    className={loginMethod == "email" ? "border-b border-brandgold" : ""}
                    onPress={() => {
                      setLoginMethod("email");
                    }}
                  >
                    <Text
                      className={
                        loginMethod == "email"
                          ? "text-sm font-medium text-brandgold px-4 py-2 uppercase"
                          : "text-sm font-medium text-[#4E5969] px-4 py-2 uppercase"
                      }
                    >
                      {i18n.t("login.email")}
                    </Text>
                  </TouchableOpacity>
                </View>

                {loginMethod == "mobile" && (
                  <>
                    <Text className="color-[#4E5969] text-s mt-6 font-semibold hover:border-none font-NunitoSans uppercase">
                      {i18n.t("login.mobile2")}
                    </Text>
                    <View className="relative mt-1">
                      <InternationalPhoneInput setValidPhone={setValidPhone} setPhone={setPhone} setDialCode={setDialCode} />    
                    </View>
                  </>
                )}

                {loginMethod == "email" && (
                  <>
                    <Text className="color-[#4E5969] text-s mt-6 font-semibold hover:border-none font-NunitoSans uppercase">
                      {i18n.t("login.email")}
                    </Text>
                    <View className="relative">
                      <TextInput
                        placeholder=""
                        onChangeText={setUser}
                        value={user}
                        className="h-9 w-full bg-[#F2F3F5] color-[#121212] mt-1 px-4"
                      ></TextInput>
                      <TouchableOpacity
                        onPress={() => {
                          resetUser();
                        }}
                        className="absolute top-[14px] right-[10px]"
                      >
                        <Image
                          source={require("../assets/icons/icon-delete.png")}
                          className="w-[17px] h-[17px]"
                        />
                      </TouchableOpacity>
                    </View>
                  </>
                )}

                <Text className="color-[#4E5969] text-s mt-6 font-semibold hover:border-none font-NunitoSans uppercase">
                  {i18n.t("otp.verification_code")}
                </Text>
                <View className="flex flex-row justify-between items-center">
                  <View className="flex-1 mr-2">
                    <TextInput placeholder="" onChangeText={setOtpCode} value={otpCode} className="w-full h-9 bg-[#F2F3F5] color-[#121212] mt-1 px-4 "></TextInput>
                  </View>
                  {
                    otpStatus == 0 &&
                    <TouchableOpacity onPress={() => { otpCaptcha(); }} >
                      <View className="flex-1 h-9 max-h-9 bg-white border border-brandgold mt-1">
                        <Text className="text-brandgold h-9 leading-9 text-center font-PingFangSC uppercase px-4">{i18n.t("otp.send_code")}</Text>
                      </View>
                    </TouchableOpacity>
                  }
                  {
                    otpStatus == 1 &&
                    <TouchableOpacity>
                      <View className="flex-1 h-9 max-h-9 bg-white border border-[#9E9E9E] mt-1">
                        <Text className="text-[#9E9E9E] h-9 leading-9 text-center font-PingFangSC uppercase px-4">{i18n.t("otp.resend_code")} <Text className="text-red-500 lowercase">({otpCoutdown}{i18n.t("otp.sec")})</Text></Text>
                      </View>
                    </TouchableOpacity>
                  }
                  {
                    otpStatus == 2 &&
                    <TouchableOpacity onPress={() => { otpCaptcha(); }} >
                      <View className="flex-1 h-9 max-h-9 bg-white border border-brandgold mt-1">
                        <Text className="text-brandgold h-9 leading-9 text-center font-PingFangSC uppercase px-4">{i18n.t("otp.resend_code")}</Text>
                      </View>
                    </TouchableOpacity>
                  }
                  {
                    otpStatus == 3 &&
                    <TouchableOpacity>
                      <View className="flex-1 h-9 max-h-9 bg-white border border-brandgold mt-1">
                        <Text className="text-brandgold h-9 leading-9 text-center font-PingFangSC uppercase px-4">✓</Text>
                      </View>
                    </TouchableOpacity>

                  }
                </View>

                {formErr ? <Text className="color-red-500 my-1">{errMsg}</Text> : null}

                {recaptchaErr && (
                  <Text className="color-red-500 my-1">{i18n.t("signUp.captcha_errMsg")}</Text>
                )}

                {codeSent ? <Text className="color-green-500 my-1">{codeSentMsg}</Text> : null}

                <TouchableOpacity
                  className="w-full h-10 max-h-10 bg-brandgold mt-4"
                  onPress={() => {
                    otpSignIn();
                  }}
                >
                  <Text className="text-white w-full h-10 leading-10 text-center font-normal font-PingFangSC uppercase">
                    {i18n.t("login.login")}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  className="w-full h-10 max-h-10 bg-white border border-brandgold mt-3"
                  onPress={() => {
                    goSignUp();
                  }}
                >
                  <Text className="text-brandgold w-full h-10 leading-10 text-center font-normal font-PingFangSC uppercase">
                    {i18n.t("login.register")}
                  </Text>
                </TouchableOpacity>

                <Text className="text-[#1111111] text-xs mt-2 font-NunitoSans">
                  {i18n.t("login.txt")}
                  <Text
                    className="underline text-black"
                    onPress={() => navigation.push("Privilege")}
                  >
                    {i18n.t("login.txt_2")}
                  </Text>
                </Text>
              </View>
            </View>

            {captchaOverlay &&
              <CaptchaConfirm closeBtnAction={() => setCaptchaOverlay(false)} callback={(res) => sendOtp(res)} captchaImg={captchaImg} captchaErr={captchaErr}
              />
            }
          </ScrollView>

          <Footer />
          <CookieConsent />
        </SafeAreaView>
      </ImageBackground>
    </View>
  );
};

export default OtpLogin;
